let observer = null

function getElementToObserve (el, binding) {
  let elementToObserve = el
  // Check if we should observe a parent
  if (binding.arg === 'parent') {
    if (!el.parentElement) {
      // Observe document
      elementToObserve = document.documentElement
    } else {
      // Observe direct parent
      elementToObserve = el.parentElement
    }
  }
  return elementToObserve
}

export default {
  inserted: (el, binding, vnode) => {
    if (!('ResizeObserver' in window)) return
    const elementToObserve = getElementToObserve(el, binding)
    
    // Save config in the element itself
    const existingCallbacks = elementToObserve.resizeObserverConfig?.callbacks || []
    const existingVnodes = elementToObserve.resizeObserverConfig?.vnodes || []
    elementToObserve.resizeObserverConfig = {
      callbacks: [...existingCallbacks, binding.value.callback || (() => {})],
      vnodes: [...existingVnodes, vnode || {}],
    }

    if (!observer) {
      // Create new observer if we don't have one
      observer = new ResizeObserver((entries) => {
        window.requestAnimationFrame(() => {
          entries.forEach(entry => {
            const config = entry.target.resizeObserverConfig
            let measurements = {
              bottom: entry.contentRect.bottom,
              height: entry.contentRect.height,
              left: entry.contentRect.left,
              right: entry.contentRect.right,
              top: entry.contentRect.top,
              width: entry.contentRect.width,
              x: entry.contentRect.x,
              y: entry.contentRect.y,
            }

            // Add width and height INCLUDING padding to the measurements
            if (entry.borderBoxSize) {
              // Normalize, for Firefox's implementation isn't an array
              const borderBoxSize = Array.isArray(entry.borderBoxSize) ? entry.borderBoxSize[0] : entry.borderBoxSize
              measurements.inlineSize = borderBoxSize.inlineSize || entry.target.offsetWidth
              measurements.blockSize = borderBoxSize.blockSize || entry.target.offsetHeight
            } else {
              // Normalize, for browsers like Safari 
              const borderBoxSize = entry.target.getBoundingClientRect()
              measurements.inlineSize = borderBoxSize.width
              measurements.blockSize = borderBoxSize.height
            }

            // Pass measurements and context to each callback
            config.callbacks.forEach((callback, index) => {
              if (callback instanceof Function) {
                callback(measurements, config.vnodes[index].context)
              }
            })
          })
        })
      })
    }

    // Observe the element
    observer.observe(elementToObserve)
  },
  unbind: (el, binding) => {
    if (observer) {
      // Remove element from the observer
      const observedElement = getElementToObserve(el, binding)
      if (observedElement) {
        observer.unobserve(observedElement)
      }
    }
  },
}